import { render, staticRenderFns } from "./UsersManage.vue?vue&type=template&id=0c871b3a&scoped=true"
import script from "./UsersManage.vue?vue&type=script&lang=js"
export * from "./UsersManage.vue?vue&type=script&lang=js"
import style0 from "./UsersManage.vue?vue&type=style&index=0&id=0c871b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c871b3a",
  null
  
)

export default component.exports